export default [
  {
    path: '/news/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'news',
        component: () => import('@/views/News/News.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: 'newsEdit',
        name: 'newsEdit',
        component: () => import('@/views/News/NewsEdit.vue'),
        meta: {
          prev: 'news'
        }
      },
      {
        path: 'newsDetail/:id',
        name: 'newsDetail',
        component: () => import('@/views/News/NewsDetail.vue'),
        meta: {
          prev: 'news'
        }
      }

    ]
  }
]
